'use strict';

import teamsCtrl from './teams-ctrl';

const MODULE_NAME = 'daupler.teams';

var app = angular.module(MODULE_NAME, [
]);
app.controller('TeamsCtrl', teamsCtrl);

export default MODULE_NAME;
